module.exports = __webpack_public_path__ + "img/流程-3.77792b06.jpg";